import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import * as graphql from 'generated/graphql';
import HelpLink from 'packages/kakapo-ui-kit/components/intercom/HelpLink';
import { DashboardDepartmentsSelector } from 'packages/kakapo-ui-application/pages/dashboard/DashboardDepartmentsSelectorModal';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';
import SettingsTable from 'packages/kakapo-ui-kit/components/common/SettingsTable';
import SettingsCollection from 'packages/kakapo-ui-settings-application/pages/generic/SettingsCollection';

import CreateDepartment from './CreateDepartment';

export default function OrganizationDepartments() {
	const { t } = useTranslation();

	const query = graphql.useDepartmentsWithParentsQuery({
		variables: {
			filter: {
				types: [graphql.GroupType.Department],
				isArchived: false,
			},
			first: 1000,
		},
	});

	return (
		<>
			<SettingsTable
				title={t(`settings.departments.title`)}
				description={t(`settings.departments.description`)}
				toolbar={<CreateDepartment />}
			>
				<Box pt={3}>
					<Box mb={3}>
						<HelpLink id="help.settings.departments" />
					</Box>
					{query.data ? (
						<DashboardDepartmentsSelector
							canSelect={() => true}
							groups={query.data.groups.edges.map(({ node }) => node as graphql.Group)}
							selection={[]}
							onChange={() => {}}
							selectable={false}
							link
							expanded
						/>
					) : (
						<Spinner isLoading size="18px" />
					)}
				</Box>
			</SettingsTable>
			<Box mt={4}>
				<SettingsCollection
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					lazyQuery={graphql.useDepartmentsLazyQuery as any}
					field="groups"
					translationKey="settings.departments"
					title={(group: graphql.Group) => group.name}
					link={(title) => `/settings/departments/${title.id}`}
					variables={{}}
				/>
			</Box>
		</>
	);
}
